module.exports = __webpack_public_path__ + "static/teddybike5-79456cbf870d6b220f1dfb470ad43bab.png";